import type { Mode, Params } from './types';

const key = (mode: Mode) => `vektor:params:${mode}`;

export function loadParams(mode: Mode): Params | null {
  try {
    const raw = localStorage.getItem(key(mode));
    if (!raw) return null;
    return JSON.parse(raw) as Params;
  } catch {
    return null;
  }
}

export function saveParams(mode: Mode, params: Params): void {
  try {
    localStorage.setItem(key(mode), JSON.stringify(params));
  } catch {
    // quota exceeded — silently ignore; UX still works in-session
  }
}
